/* vhx product page — gallery thumbnails, plan→CTA price sync, add-to-cart drawer wiring. */
(function () {
  "use strict";
  document.querySelectorAll(".vhx-product-page").forEach(function (root) {
    // ---- gallery ----
    var main = root.querySelector(".vhx-gallery__main img");
    var thumbs = root.querySelectorAll(".vhx-gallery__thumb");
    thumbs.forEach(function (b) {
      b.addEventListener("click", function () {
        var full = b.getAttribute("data-full");
        if (full && main) main.src = full;
        thumbs.forEach(function (t) { t.classList.remove("is-active"); });
        b.classList.add("is-active");
      });
    });

    // ---- plan selection updates the CTA price + the real cart variant id ----
    var cta = root.querySelector("[data-vhx-cta]");
    var variantInput = root.querySelector("[data-vhx-variant]");
    root.querySelectorAll('input[type="radio"][data-price]').forEach(function (r) {
      r.addEventListener("change", function () {
        if (!r.checked) return;
        // data-cta is the per-day figure; data-price (the plan total) stays for the sticky bar
        if (cta) cta.textContent = (cta.getAttribute("data-base") || "Add to cart") + " · " + (r.getAttribute("data-cta") || r.getAttribute("data-price"));
        var vid = r.getAttribute("data-variant");
        if (variantInput && vid) variantInput.value = vid;
        var spInput = root.querySelector("[data-vhx-sp]");
        if (spInput) {
          var sp = r.getAttribute("data-sp") || "";
          spInput.value = sp;
          spInput.disabled = !sp;
        }
        // Subscription is a fixed recurring box: hide the qty stepper and pin qty to 1.
        // One-time purchase swaps the frequency select for the stepper (buy several boxes).
        var bb2 = root.querySelector(".vhx-bb2");
        if (bb2) bb2.classList.toggle("is-once", r.value === "once");
        if (r.value === "sub") {
          var qi = root.querySelector('.vhx-bb2__qty input[name="quantity"]');
          if (qi) qi.value = 1;
        }
      });
    });

    // ---- add to cart: AJAX add + open the theme's native cart drawer, instead of the
    // plain form POST's default full-page navigation to /cart. Uses the theme's own
    // "cart:change" event contract (see assets/theme.js CartDrawer.onCartChange), so this
    // reuses the drawer's real rendering/animation rather than reimplementing it. ----
    var form = root.querySelector("[data-vhx-form]") || root.querySelector("form.vhx-buyform");

    // ---- quantity stepper (DIRTEA-style buy module) ----
    root.querySelectorAll("[data-vhx-qty]").forEach(function (q) {
      var input = q.querySelector('input[name="quantity"]');
      q.querySelectorAll("button[data-q]").forEach(function (b) {
        b.addEventListener("click", function () {
          var v = parseInt(input.value, 10) || 1;
          v += parseInt(b.getAttribute("data-q"), 10);
          input.value = Math.min(9, Math.max(1, v));
        });
      });
    });
    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) submitBtn.disabled = true;

        // The cart-drawer's real Shopify section ID is not the literal string "cart-drawer" —
        // Shopify's "overlay group" mechanism teleports <cart-drawer> to a direct child of
        // <body>, detached from its original .shopify-section-* wrapper (confirmed live via
        // DOM inspection: cart-drawer.parentElement === document.body). The theme's own
        // CartDrawer class resolves its real section ID once, on first connectedCallback,
        // while still inside that wrapper — this code can't reach that private field, so it
        // independently finds the same wrapper by matching on the drawer's element id instead.
        var sectionId = "cart-drawer";
        var wrapper = document.querySelector('.shopify-section[id$="__cart-drawer"], .shopify-section--cart-drawer');
        if (wrapper && wrapper.id) sectionId = wrapper.id.replace("shopify-section-", "");

        var formData = new FormData(form);
        var item = { id: formData.get("id"), quantity: formData.get("quantity") || 1 };
        var sp = formData.get("selling_plan");
        if (sp) item.selling_plan = sp;
        var payload = { items: [item], sections: sectionId };

        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(payload)
        })
          .then(function (res) {
            if (!res.ok) throw new Error("Add to cart failed: " + res.status);
            return res.json();
          })
          .then(function (data) {
            var sections = {};
            sections[sectionId] = data.sections[sectionId];
            document.dispatchEvent(new CustomEvent("cart:change", {
              detail: {
                cart: { sections: sections },
                baseEvent: "variant:add",
                onSuccessDo: "force_open_drawer"
              }
            }));
          })
          .catch(function (err) {
            // Fall back to the original, always-correct behaviour if the AJAX path fails
            // for any reason, rather than silently doing nothing.
            console.error(err);
            form.submit();
          })
          .finally(function () {
            if (submitBtn) submitBtn.disabled = false;
          });
      });
    }
  });
})();
